import { serviceLogger } from '../Logger';

const log = serviceLogger.scope('detailview-client');

export class DetailviewClient {
	constructor() {
	}

	getFromTeaserUI(): Promise<string> {
		const url = `/up-teaserui/detailview`;

		log.info(`[FT9BCN] Calling detailview teaser endpoint on url: ${JSON.stringify(url)}`);

		return fetch(url, {
			method: 'GET',
			headers: {
				Accept: 'text/html'
			}
		}).then((response) => {
			if (response.status === 200) {
				log.info(`[FT9BCN] detailview teaser html fetched successfully`);
				return response.text();
			}
			return Promise.reject(
				`Got status code '${response.status}' for detailview teaser`);
		});
	}
}

